import { lazy } from 'react';

const QuestionEditPage = lazy(() =>
  import('./question/[id].js').then((module) => ({ default: module.NewQuestionEditPage })),
);

const ChapterEditPage = lazy(() =>
  import('./chapter/[id].js').then((module) => ({ default: module.ChapterEditPage })),
);

export { ChapterEditPage, QuestionEditPage };
